import { Row } from "reactstrap";
import { Component, ErrorInfo, ReactNode } from "react";
import SearchInput from "./SearchInput/SearchInput";
import HeaderLogo from "./HeaderLogo/HeaderLogo";
import LeftHeader from "./LeftHeader/LeftHeader";
import RightHeader from "./RightHeader/RightHeader";
import { useAppSelector } from "../../ReduxToolkit/Hooks";

// Error Boundary para el Header
class HeaderErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error en Header:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Si hay error, renderizar Header básico sin componentes que usan useAuth
      return (
        <div className="page-header" id="pageheaders">
          <Row className="header-wrapper m-0">
            <HeaderLogo />
          </Row>
        </div>
      );
    }

    return this.props.children;
  }
}

const Header = () => {
  const { toggleSidebar, scroll } = useAppSelector((state) => state.layout);
  
  return (
    <HeaderErrorBoundary>
      <div className={`page-header ${toggleSidebar ? "close_icon" : ""}`} id="pageheaders" style={{display: scroll ? "none" : ""}}>
        <Row className="header-wrapper m-0">
          <SearchInput />
          <HeaderLogo />
          <LeftHeader />
          <RightHeader />
        </Row>
      </div>
    </HeaderErrorBoundary>  );
};

export default Header;
